import {AfterViewInit, Component, EventEmitter, OnInit, Output} from '@angular/core';
import {BarcodeScanner} from '@capacitor-community/barcode-scanner';
import {AlertController} from '@ionic/angular';
import {Capacitor} from '@capacitor/core';
import {ALERT_TXT} from '../../strings/language';

@Component({
	selector: 'app-regisafe-barcode-scanner',
	templateUrl: './regisafe-barcode-scanner.component.html',
	styleUrls: ['./regisafe-barcode-scanner.component.scss'],
})
export class RegisafeBarcodeScannerComponent implements OnInit, AfterViewInit {

	@Output() scanIsActiv: EventEmitter<any> = new EventEmitter<any>();
	@Output() scanResult: EventEmitter<any> = new EventEmitter<any>();
	scanActiv = false;

	constructor(private alertCtrl: AlertController) {
	}

	ngOnInit() {
	}

	ngAfterViewInit() {
		if (Capacitor.getPlatform() !== 'web') {
			BarcodeScanner.prepare();
		}
	}

	ionViewDidLeave() {
		if (Capacitor.getPlatform() !== 'web') {
			BarcodeScanner.stopScan();
		}
		this.scanIsActiv.emit(false);
		this.scanActiv = false;
	}

	async scanBarcode() {
		const allowed = await this.checkPermissions();
		if (allowed) {
			this.scanIsActiv.emit(true);
			this.scanActiv = true;
			const result = await BarcodeScanner.startScan();
			if (result.hasContent) {
				try {
					console.log('scanBarcode: ', result.content);
					console.log('scanBarcode json: ', result.content);
					this.scanResult.emit(result.content);
					this.stopScanner();
				} catch (e) {
					console.log('scanBarcode error: ', e);
					this.stopScanner();
				}

			}
		}

	}

	async checkPermissions() {
		return new Promise(async (resolve, reject) => {
			const status = await BarcodeScanner.checkPermission({force: true});
			if (status.granted) {
				resolve(true);
			} else if (status.denied) {

				const alert = await this.alertCtrl.create({
					header: ALERT_TXT.header.str00030,
					message: ALERT_TXT.message.str00020,
					buttons: [{
						text: ALERT_TXT.buttons.str00010,
						role: 'cancel'
					}, {
						text: ALERT_TXT.buttons.str00040,
						handler: () => {
							BarcodeScanner.openAppSettings();
							resolve(false);
						}
					}]
				});
				await alert.present();

			} else {
				resolve(false);
			}
		});
	}

	stopScanner() {
		BarcodeScanner.stopScan();
		this.scanIsActiv.emit(false);
		this.scanActiv = false;
	}
}
